import React, { useMemo } from 'react';
import { useSeoMeta } from '../../hooks/useSeoMeta';
import { useJsonLd } from '../../hooks/useJsonLd';
import { useLanguage } from '../../contexts/LanguageContext';
import { homePageJsonLd } from '../../seo/jsonLd';
import HomeRedesignHero from './HomeRedesignHero';
import HomeRedesignMarquee from './HomeRedesignMarquee';
import HomeRedesignLessAlone from './HomeRedesignLessAlone';
import HomeRedesignTestimonials from './HomeRedesignTestimonials';
import HomeRedesignChat from './HomeRedesignChat';
import HomeRedesignPromise from './HomeRedesignPromise';
import HomeRedesignCities from './HomeRedesignCities';
import HomeRedesignFinalCta from './HomeRedesignFinalCta';
import { OG_IMAGE_URL } from './cityLinks';
import { useHomeRedesignStrings } from './useHomeRedesignStrings';

const HomeRedesign: React.FC = () => {
  const { currentLanguage } = useLanguage();
  const { seo } = useHomeRedesignStrings();

  useSeoMeta({
    title: seo.title,
    description: seo.description,
    url: 'https://chisme.social/',
    image: OG_IMAGE_URL,
    locale: currentLanguage === 'en' ? 'en' : 'es',
  });

  const jsonLd = useMemo(() => homePageJsonLd(), []);
  useJsonLd(jsonLd);

  return (
    <>
      <HomeRedesignHero />
      <HomeRedesignMarquee />
      <HomeRedesignLessAlone />
      <HomeRedesignTestimonials />
      <HomeRedesignChat />
      <HomeRedesignPromise />
      <HomeRedesignCities />
      <HomeRedesignFinalCta />
    </>
  );
};

export default HomeRedesign;
